<template>
  <div :class="$style.overlay__share">
    <van-overlay :show="show" duration="0.05" @click="close" />
  </div>
</template>

<script>
import { register } from '@/plugin/popup'
export default {
  data() {
    return {
      show: false
    }
  },
  mounted() {
    register({
      name: 'OverlayShare',
      open: ({ afterClose }) => {
        this.afterClose = afterClose
        this.open()
      },
      close: () => {
        this.close()
      }
    })
  },
  methods: {
    close() {
      this.show = false
      if (this.afterClose) {
        this.afterClose()
      }
    },
    open() {
      this.show = true
    }
  }
}
</script>

<style lang="scss" module>
.overlay__share {
  :global(.van-overlay) {
    z-index: 199;
    background-image: url(https://img.yzcdn.cn/upload_files/2020/02/13/FiCH-1H3Sn8BDtOdKAqc40lrAD_j.png);
    background-repeat: no-repeat;
    background-size: 100% auto;
  }
}
</style>
